export const monitorSFKB = () => { // Sentral Felles KartdataBase
  const monitor = document.createElement('div');
  monitor.id = 'monitor';
  document.body.appendChild(monitor);

  // Toggle window:
  const header = document.createElement('p');
  header.style.margin = '0';
  header.style.textAlign = 'center';
  const a = document.createElement('a');
  a.style.cursor = 'pointer';
  a.style.textDecoration = 'unset';
  a.style.marginRight = '62px';
  a.onclick = () => monitor.classList.toggle('opened');
  const rt = document.createElement('span');
  const dt = document.createElement('span');
  rt.id = 'rightTriangle';
  dt.id = 'downTriangle';
  rt.innerHTML = '&#9656;';
  dt.innerHTML = '&#9662;';
  const title = document.createElement('u');
  title.style.marginLeft = '4px';
  title.innerHTML = 'SFKB status';
  a.appendChild(rt);
  a.appendChild(dt);
  a.appendChild(title);
  header.appendChild(a);

  // Save status:
  const save = document.createElement('a');
  save.innerHTML = '&#128190;';
  save.title = 'Lagre status';
  save.style.cursor = 'pointer';
  save.style.position = 'absolute';
  save.style.right = '48px';
  save.download = 'status.json'; // file name
  const fileFormat = 'data:application/json;charset=utf-8,';
  header.appendChild(save);
  monitor.appendChild(header);

  const list = document.createElement('ul');
  monitor.appendChild(list);

  const æøå = t => t.replace(/Ã¥/g, 'å').replace(/Ã¸/g, 'ø').replace(/Ã¦/g, 'æ');

  const appendJsonToList = (json, list) => {
    const li = document.createElement('li');
    // console.log(json);
    li.className = 'greenJob';
    if (!json.doneJobTime && !json.startJobTime) li.className = 'orangeJob';
    if (!json.doneJobTime && json.startJobTime) li.className = 'lightgrayJob';
    if (json.doneJobTime && !json.isOkResult) li.className = 'redJob';
    // li.innerHTML = JSON.stringify(json);
    li.innerHTML = `${json.jobType} (${json.executeTime} ms) `;
    const copyId = document.createElement('a');
    copyId.innerHTML = '&#128203;';
    copyId.title = 'Kopi av transaksjons UUID';
    copyId.style.cursor = 'pointer';
    copyId.onclick = () => navigator.clipboard.writeText(json.uuid);
    li.appendChild(copyId);
    const nestedList = document.createElement('ul');
    li.appendChild(nestedList);
    [
      // 'uuid',
      // 'executeTime',
      // 'isOkResult',
      'ngisError'
    ].forEach(key => {
      if (key === 'isOkResult' && !json[key]) return;
      let value = json[key];
      if (key === 'ngisError') {
        if (!value) return;
        if (value === 'Moved to another area') {
          li.className = 'greenJob';
          li.innerHTML = li.innerHTML.replace('null ms', 'avbrutt');
          return;
        }
        if (value.charAt(0) === '{') {
          const j = JSON.parse(value);
          if (!j.errors) return;
          value = `<b>${j.errors[0].reason}</b>`;
        } else value = `<b>${value}</b>`;
        value = æøå(value);
      }
      const nestedItem = document.createElement('li');
      nestedItem.innerHTML = `${key}:&nbsp${value}`;
      nestedItem.innerHTML = value;
      nestedList.appendChild(nestedItem);
    });

    // More details on mouseover:
    li.title = æøå(JSON.stringify(json));

    list.appendChild(li);
    return li.className.replace('Job', '');
  };

  const timestamp = (filename) => {
    const f = filename.split('.');
    const now = new Date();
    const date = now.toLocaleDateString('no-NO').replace(/\./g, '-');
    const time = now.toLocaleTimeString('no-NO').slice(0, 5).replace(':', '-');
    return `${f[0]}_${date}_${time}.${f[1]}`
  };

  const refreshMonitor = jsonString => {
    list.innerHTML = ''; // empty job list
    if (!jsonString) return;
    save.download = timestamp('status.json'); // file name
    save.href = fileFormat + encodeURIComponent(jsonString);
    const jsonArray = JSON.parse(jsonString).reverse(); // most recent first
    const colourCount = { green: 0, red: 0, orange: 0, lightgray: 0 };
    jsonArray.forEach(json => colourCount[appendJsonToList(json, list)] += 1);
    // console.log(jsonArray.length, colourCount);
    for (let [colour, occurrencies] of Object.entries(colourCount)) {
      if (occurrencies > 0) monitor.classList.add(`${colour}Border`);
      else monitor.classList.remove(`${colour}Border`);
    }
    // monitor.scrollTop = monitor.scrollHeight; // scroll to bottom
  };

  const href = window.location.href;
  const xhr = new XMLHttpRequest();
  xhr.onload = () => {
    // console.log('Loaded', xhr.status);
    if (xhr.status === 200) {
      // console.log(xhr.response);
      refreshMonitor(xhr.response);
    } else {
      monitor.innerHTML = 'Feil ved henting av SFKB-status!';
    }
  };
  const status = () => {
    xhr.open('GET', '/ar5web_ws/rest/ngisjobstatus');
    // xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send();
  };

  const interval = setInterval(status, 5000); // Time in milliseconds
  // clearInterval(interval);
};
